export class NihiiHelper {
  public static normalizeToNihii8(value: string): string {
    return value.replace(/\D/g, '').slice(0, 8);
  }

  public static hasValidCheckDigit(normalizedNihii: string): boolean {
    const baseNihii: number = Number.parseInt(normalizedNihii.slice(0, 6), 10);
    const checkDigit: string = normalizedNihii.slice(6, 8);

    return [97, 89, 83, 79].some((modulus: number): boolean => {
      const computedCheckDigit: number = modulus - (baseNihii % modulus);

      return String(computedCheckDigit).padStart(2, '0') === checkDigit;
    });
  }
}
